import React from 'react';
import PropTypes from 'prop-types';
import withBangingAnimator from 'containers/withBangingAnimator';
import withPendingSpinEnd from 'containers/withPendingSpinEnd';
import PointValueContainer from 'components/PointValueContainer';
import PointValueDisplay from 'components/PointValueDisplay';
import shouldUpdate from 'utils/shouldUpdate';
import './GameScoreDisplay.css';

const AnimatedPointValueDisplay = withPendingSpinEnd()(
  withBangingAnimator()(PointValueDisplay)
);

function GameScoreDisplay({
  className,
  transitionClass,
  gameScore,
  children,
  ...otherProps
}) {
  if (gameScore === undefined) {
    return null;
  }

  return (
    <div className={`game-score-display ${transitionClass} ${className}`}>
      <PointValueContainer icon="gamePoints">
        <AnimatedPointValueDisplay
          value={gameScore}
          enableScaling={false}
          {...otherProps}
        />
        {children}
      </PointValueContainer>
    </div>
  );
}

GameScoreDisplay.propTypes = {
  transitionClass: PropTypes.string,
  gameScore: PropTypes.number
};

function shouldComponentUpdate(props, nextProps) {
  return (
    props.transitionClass !== nextProps.transitionClass ||
    props.gameScore !== nextProps.gameScore ||
    props.className !== nextProps.className
  );
}

export default shouldUpdate(shouldComponentUpdate)(GameScoreDisplay);
